import axios from '@/API/request';

export function getMapDate(data) {
  return axios({
    url: '/auth/login',
    method: 'post',
    data,
  });
}
export function login() {
  return axios({
    url: '/user/info',
    method: 'get',
  });
}
//废旧物资回收、拆解量
export function getAmountOfDismantling(adcode, data) {
  return axios({
    url: `/resource/api/data/query/${adcode}`,
    method: 'get',
    params: data,
  });
}
// 获取站点详情数据
export function getStatiosTypedata(id, typeValue,data) {
  return axios({
    url: `/resource/api/data/typedata/${id}/${typeValue}`,
    method: 'get',
    params: data,
  });
}
// 大屏数据撒点
export function getPointList(data) {
  return axios({
    url: `/resource/api/station/map/query`,
    method: 'get',
    params: data,
  });
}

// 根据站点ID查询站点详情数据
export function getComponyInfomation(stationid) {
  return axios({
    url: `/resource/api/station/${stationid}/data`,
    method: 'get',
  });
}
//根据typecode查询该类型下的类别数据
export function getCategories(data) {
  return axios({
    url: `/resource/api/dictionary/item/list/typecode`,
    method: "get",
    params:data
  });
}

// 概览数据title获取
export function getOverViewName(type) {
  return axios({
    url: `/resource/api/data/overview-data/${JSON.stringify(type)}`,
    method: "get",
  });
}

